import React from 'react';
import { Button, makeStyles } from '@material-ui/core';
import CheckListRtl from '../icons/CheckListRtl';
import botaoStyles from './Botao.styles';

const useStyles = makeStyles((theme) => ({
  button: {
    ...botaoStyles
  }
}));

function BotaoImprimirNotaFiscal(props) {
  const classes = useStyles();

  const variant = props.variant || 'contained';

  return (
    <Button
      variant={variant}
      className={variant === 'contained' ? classes.button : ''}
      endIcon={<CheckListRtl disabled={props.disabled} variant={variant} />}
      {...props}
    >
      Imprimir nota fiscal
    </Button>
  )
}

export default BotaoImprimirNotaFiscal;